var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03032 0C4.03542 0 3.06286 0.295023 2.23563 0.847762C1.40839 1.4005 0.763646 2.18613 0.382913 3.1053C0.0021795 4.02447 -0.0974376 5.0359 0.0966585 6.01169C0.290755 6.98748 0.769846 7.88379 1.47335 8.5873C2.17685 9.2908 3.07317 9.76989 4.04896 9.96399C5.02474 10.1581 6.03617 10.0585 6.95534 9.67773C7.3606 9.50987 7.7399 9.29069 8.08472 9.02717L10.8621 11.8045C11.1224 12.0649 11.5446 12.0649 11.8049 11.8045C12.0653 11.5442 12.0653 11.1221 11.8049 10.8617L9.02749 8.08431C9.09187 8.00004 9.15371 7.91357 9.21288 7.82502C9.76562 6.99779 10.0606 6.02518 10.0606 5.03028C10.0606 3.69619 9.53056 2.41677 8.58722 1.47343C7.64387 0.530087 6.36441 8.49168e-05 5.03032 0ZM7.64441 2.41624C6.9511 1.72293 6.0108 1.33341 5.03032 1.33333C4.29914 1.33334 3.58434 1.55017 2.97639 1.95639C2.36842 2.36262 1.89457 2.94001 1.61475 3.61555C1.33494 4.29108 1.26172 5.03442 1.40437 5.75157C1.54702 6.46871 1.89913 7.12745 2.41616 7.64449C2.93319 8.16152 3.59193 8.51362 4.30908 8.65627C5.02622 8.79892 5.76956 8.72571 6.4451 8.44589C7.12064 8.16608 7.69803 7.69223 8.10426 7.08426C8.51048 6.4763 8.7273 5.7615 8.72731 5.03032C8.72724 4.04984 8.33771 3.10954 7.64441 2.41624Z",
    fill: "#8B9CB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying_glass.da164e33843b9e6c9b061d8bc9ba2b8b.svg";
export { ForwardRef as ReactComponent };